export enum ContractType {
    New = 'New',
    Extension = 'EXT',
    Legacy = 'LEG'
}
